import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddTrainingsModel } from 'src/app/Models/addTrainingsModel';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AddTrainingsService {

  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  private gsdUrl = environment.GSDapiUrl

  getAllServiceLines() {
    const url = `${this.apiUrl}Competency/GetAllServiceAreas`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getCompetencyName(id) {
    const url = `${this.apiUrl}Competency/GetCompetencyNameById?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getServiceLinesForDropdown() {
    const url = `${this.apiUrl}Competency/GetCompetenciesForDropDowns`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getSubServiceLinesForDropdown(id) {
    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getTrainerDetails(searchText: any) {
    const url = `${this.apiUrl}Profile/Autocomplete?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getSessionLocations() {
    const url = `${this.apiUrl}Training/GetLocation`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public addTrainingDetails(data: AddTrainingsModel): Observable<any> {
    const url = this.apiUrl + 'Training/SaveTraining';
    return this.http.post<AddTrainingsModel>(url, data, this.httpOptions);
  }

  getSessionType() {
    const url = `${this.apiUrl}TrainingSession/GetTrainingType`;
    return this.http.get<any>(url, this.httpOptions);
  }
}

